export const METRIC_TO_TITLE = {
  max: 'Maximum Temperature',
  min: 'Minimum Temperature',
  mean: 'Average Temperature',
}